var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"humanize-container"},[_c('simple-list',{attrs:{"store":_vm.orders,"name-prop":"number","details-route":"order-basic","filterable":false},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var record = ref.record;
return [_c('order-list-item',{attrs:{"order":record}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }